import { useEventContext } from "contexts";
import { Link } from "react-router-dom"
import { NavUtils, NavPages } from "utils";

export const NotImplemented = () => {
    const event = useEventContext();
    return (
        <div className="aq-content">
            Not implemente yet...
            <br/>
            <Link to={NavUtils.generateNavPath(NavPages.Root, undefined, event?.alias)}>Return to quiz list</Link>
        </div>
    );
}
    
